/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useUserInfo } from "@/global-data/use-user-info";
import { useToast } from "@/hooks/use-toast";
import { getUserInfo } from "@/lib/token";
import { apiServices } from "@/services/api.services";
import { users } from "@/services/global.services";
import { useEffect, useMemo, useState } from "react";

export const useApp = () => {
  const [process, setProcess] = useState(true);
  const { setUser } = useUserInfo();

  const { toast } = useToast();
  const { user_id, company_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (user_id && company_id) {
        // await loadUser();
        const userInfo: any = await loadUser();
        // console.log({ userInfo });
        if (userInfo?.data) {
          setUser(userInfo?.data);
        }
        setProcess(false);
      }
    })();
  }, [user_id, company_id]);

  const loadUser = async () => {
    const payload = {
      data: {
        user_id: user_id,
        filter_by: {
          user_id: user_id,
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices(
      users.get,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data: data?.result?.metadata?.users?.[0], error };
  };

  return { process };
};
